
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise",
      function () {
        return require("private-next-pages/enterprise/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise"])
      });
    }
  